import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//v3.0以上某个新版本-避免到当前位置“/路径”的冗余导航（避免重复导航报错）
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({
        y: 0
    }),
    routes: [{
        path: '/',
        redirect: 'index',
    }, {
        path: '/index',
        name: 'index',
        component: (resolve) => require(['@/views/index'], resolve)
    }, {
        path: '/login',
        name: 'login',
        component: (resolve) => require(['@/views/login'], resolve)
    }, {
        path: '/login_admin',
        name: 'login_admin',
        component: (resolve) => require(['@/views/login_admin'], resolve)
    },
    {
        path: '/twitter',
        name: 'twitter',
        component: (resolve) => require(['@/views/twitter'], resolve)
    },
    {
        path: '/404',
        component: (resolve) => require(['@/views/error/404'], resolve)
    },
    {
        path: '/401',
        component: (resolve) => require(['@/views/error/401'], resolve)
    },
    {
        path: '/productParent',
        name: 'productParent',
        component: (resolve) => require(['@/views/sdkConfig/productParent'], resolve)
    }, {
        path: '/productChild/:id',
        name: 'productChild',
        component: (resolve) => require(['@/views/sdkConfig/productChild'], resolve)
    }, {
        path: '/productConfig/:id',
        name: 'productConfig',
        component: (resolve) => require(['@/views/sdkConfig/productConfig'], resolve)
    }, {
        path: '/productTemplate/:id',
        name: 'productTemplate',
        component: (resolve) => require(['@/views/sdkConfig/productTemplate'], resolve)
    },
    {
        path: '/flowpathIndex',
        name: 'flowpathIndex',
        component: (resolve) => require(['@/views/flowpath/flowpathIndex'], resolve)
    },
    {
        path: '/flowpathDetail/:id',
        name: 'flowpathDetail',
        component: (resolve) => require(['@/views/flowpath/flowpathDetail'], resolve)
    },
    {
        path: '/feePoint',
        name: 'feePoint',
        component: (resolve) => require(['@/views/sdkConfig/feePoint/index'], resolve)
    },
    {
        path: '/payAccount',
        name: 'payAccount',
        component: (resolve) => require(['@/views/sdkConfig/payAccount'], resolve)
    },
    {
        path: '/billAccount',
        name: 'billAccount',
        component: (resolve) => require(['@/views/sdkConfig/billAccount'], resolve)
    },
    {
        path: '/orderInfo',
        name: 'orderInfo',
        component: (resolve) => require(['@/views/sdkConfig/orderInfo'], resolve)
    },
    {
        path: '/blacklist',
        name: 'blacklist',
        component: (resolve) => require(['@/views/sdkConfig/blacklist'], resolve)
    },
    {
        path: '/userlist',
        name: 'userlist',
        component: (resolve) => require(['@/views/sdkConfig/userlist'], resolve)
    },
    {
        path: '/refreshToken',
        name: 'refreshToken',
        component: (resolve) => require(['@/views/sdkConfig/refreshToken'], resolve)
    },
    {
        path: '/youyuBilllist',
        name: 'youyuBilllist',
        component: (resolve) => require(['@/views/sdkConfig/youyuBilllist'], resolve)
    },
    {
        path: '/activationCode',
        name: 'activationCode',
        component: (resolve) => require(['@/views/sdkConfig/activationCode'], resolve)
    },
    {
        path: '/activationCodeSend',
        name: 'activationCodeSend',
        component: (resolve) => require(['@/views/sdkConfig/activationCodeSend'], resolve)
    },
    {
        path: '/logoutLog',
        name: 'logoutLog',
        component: (resolve) => require(['@/views/sdkConfig/logoutLog'], resolve)
    },
    {
        path: '/userQuery',
        name: 'userQuery',
        component: (resolve) => require(['@/views/sdkConfig/userQuery'], resolve)
    }, {
        path: '/userQueryDetail/:id',
        name: 'userQueryDetail',
        component: (resolve) => require(['@/views/sdkConfig/userQueryDetail'], resolve)
    },
    {
        path: '/redpacket',
        name: 'redpacket',
        component: (resolve) => require(['@/views/sdkConfig/redpacket'], resolve)
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: (resolve) => require(['@/views/sdkConfig/agreement'], resolve)
    },
    {
        path: '/access',
        name: 'access',
        component: (resolve) => require(['@/views/sdkConfig/access'], resolve)
    },
    {
        path: '/xjjf',
        name: 'xjjf',
        component: (resolve) => require(['@/views/sdkConfig/xjjf'], resolve)
    },
    {
        path: '/xjjl',
        name: 'xjjl',
        component: (resolve) => require(['@/views/sdkConfig/xjjl'], resolve)
    },
    {
        path: '/txsh',
        name: 'txsh',
        component: (resolve) => require(['@/views/sdkConfig/txsh'], resolve)
    },
    {
        path: '/txshjl',
        name: 'txshjl',
        component: (resolve) => require(['@/views/sdkConfig/txshjl'], resolve)
    },
    {
        path: '/risk',
        name: 'risk',
        component: (resolve) => require(['@/views/sdkConfig/risk'], resolve)
    },
    // {
    //     path: '/bindlist',
    //     name: 'bindlist',
    //     component: (resolve) => require(['@/views/sdkConfig/bindList'], resolve)
    // }
    {
        path: '/independentWebsite',
        name: 'independentWebsite',
        component: (resolve) => require(['@/views/sdkConfig/independentWebsite/index'], resolve)
    },
    {
        path: '/facePic',
        name: 'facePic',
        component: (resolve) => require(['@/views/sdkConfig/facePic'], resolve)
    },
    {
        path: '/crowdPack',
        name: 'crowdPack',
        component: (resolve) => require(['@/views/sdkConfig/crowdPack'], resolve)
    },
    {
        path: '/announcement',
        name: 'announcement',
        component: (resolve) => require(['@/views/sdkConfig/announcement'], resolve)
    },
    {
        path: '/giftManage',
        name: 'giftManage',
        component: (resolve) => require(['@/views/sdkConfig/giftManage'], resolve)
    },
    {
        path: '/giftCode',
        name: 'giftCode',
        component: (resolve) => require(['@/views/sdkConfig/giftCode'], resolve)
    },
    {
        path: '/findEmail',
        name: 'findEmail',
        component: (resolve) => require(['@/views/sdkConfig/findEmail'], resolve)
    },{
        path: '/orderHangSeng',
        name: 'orderHangSeng',
        component: (resolve) => require(['@/views/sdkConfig/orderHangSeng'], resolve)
    },
    {
        path: '/payType',
        name: 'payType',
        component: (resolve) => require(['@/views/sdkConfig/payType'], resolve)
    },
    {
        path: '/sendConfig',
        name: 'sendConfig',
        component: (resolve) => require(['@/views/sdkConfig/sendConfig'], resolve)
    },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js